// extracted by mini-css-extract-plugin
export default {"person_row_container":"AdminInfo_TaxReturn_person_row_container__zAcqy","person_row":"AdminInfo_TaxReturn_person_row__ZBAvs"};